export interface GeneratorLanguages {
  clients: string[],
  servers: string[],
  documentations: string[]
}

export enum GENERATOR_SPEC_TYPE {
  CLIENT = 'CLIENT',
  SERVER = 'SERVER',
  DOCUMENTATION = 'DOCUMENTATION',
}

export enum CODEGEN_VERSION {
  V2 = 'V2',
  V3 = 'V3',
}